import * as React from 'react'

import { Box, Chevron, Text, Touchable } from '@factorialco/deprecated-design-system'
import moment from 'moment'

import { observer } from 'mobx-react'

interface Props {
  onNextPage: () => void
  onPreviousPage: () => void
  hasNextPage: boolean
  hasPreviousPage: boolean
  currentDate: number
}

const Navigator = ({
  onNextPage,
  onPreviousPage,
  hasPreviousPage,
  hasNextPage,
  currentDate,
}: Props) => {
  const date = moment.unix(currentDate).format('ll')

  return (
    <Box alignItems="center" flexDirection="row">
      <Touchable onClick={() => onNextPage()} disabled={!hasNextPage}>
        <Chevron type={hasNextPage ? 'primary' : 'terciary'} direction="left" size="big" />
      </Touchable>
      <Touchable onClick={() => onPreviousPage()} disabled={!hasPreviousPage}>
        <Chevron type={hasPreviousPage ? 'primary' : 'terciary'} direction="right" size="big" />
      </Touchable>
      <Text.Normal weight="medium">{date} </Text.Normal>
    </Box>
  )
}

export default observer(Navigator)
